// Real content for T.P. Sreenivasan personal website
// Sourced from content provided by the site owner.

export const profile = {
  name: "T.P. Sreenivasan",
  title: "Former Ambassador of India to the United Nations, Vienna",
  email: "tpsreenivasan@gmail.com",
  portrait:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/smgtjp2r_TPS-image1.jpg",
  tagline: "Diplomat • Author • Columnist • Educator",
};

export const portraits = {
  formal:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/smgtjp2r_TPS-image1.jpg",
  podium:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/d2gjlxpu_TPS-image2.jpg",
  kurta:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/w0wp3j0k_tps-photo6.jpg",
  smile:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/hk8k3016_tps-photo1.jpg",
  reading:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/9g7n0ly2_tps-photo7.jpg",
  studio:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/lr947vzg_tps-photo8.jpg",
  formal2:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/z6abcijs_tps-photo6.jpg",
};

export const contact = {
  name: "T.P. Sreenivasan",
  roles: [
    "Former Ambassador of India to the United Nations, Vienna",
    "Former Governor for India, International Atomic Energy Agency (IAEA), Vienna",
    "Managing Trustee & Director General, Kerala International Centre, Thiruvananthapuram",
  ],
  address: '"Sreelekha" J-3, Jawahar Nagar, Thiruvananthapuram 695 003, Kerala, India',
  email: "tpsreenivasan@gmail.com",
  mobile: "(91) 98477 21656",
  phone: "(91 471) 272 5456 / 272 0497",
};

export const aboutIntro = `A former Ambassador and Permanent Representative of India to the United Nations, Vienna and Governor for India of the International Atomic Energy Agency, Vienna and Ambassador to Austria and Slovenia (2000–2004), T.P. Sreenivasan has served in the Indian Foreign Service for 37 years.`;

export const biography = [
  `A former Ambassador and Permanent Representative of India to the United Nations, Vienna and Governor for India of the International Atomic Energy Agency (IAEA), Vienna and Ambassador to Austria and Slovenia (2000–2004), T.P. Sreenivasan has served in the Indian Foreign Service for 37 years.`,
  `His previous postings were as Deputy Chief of Mission (Ambassadorial Rank) in the Embassy of India, Washington (1997–2000); High Commissioner of India to Kenya and Permanent Representative of India to the United Nations in Nairobi (1995–1997); Ambassador and Deputy Permanent Representative of India to the United Nations, New York (1992–1995); and Ambassador to Fiji and eight other South Pacific Island States (1986–1989). He has also served in New Delhi, Tokyo, Thimphu, Moscow, New York and Yangon. He rose to the highest level in the Indian Foreign Service in 2001 and retired in 2004.`,
  `Mr. Sreenivasan has nearly 20 years of experience in multilateral diplomacy and has represented India at a number of international conferences organised by the United Nations, the Commonwealth and the Nonaligned Movement. He has chaired several UN Committees and Conferences.`,
  `Mr. Sreenivasan has a creditable academic record, having stood first in the University of Kerala in B.A. (English) and M.A. (English). He has won several distinctions during his student days. He speaks Japanese and Russian.`,
  `Mr. Sreenivasan was the Executive Director of 'IAEA 2020', a project launched by the Director General of the International Atomic Energy Agency, Vienna. He was a member of the National Security Advisory Board of the Government of India from 2009 to 2012. He was the Vice-Chairman and Executive Head of the Kerala State Higher Education Council with the rank of Vice-Chancellor.`,
  `He is presently the Chairman of the Academic Council and Director of the N.S.S Civil Service Academy and the Director General, Kerala International Centre. He also contributes articles regularly to Indian and foreign publications, such as the Asia Wall Street Journal, New York Times (India Ink), The Hindu, The Times of India, Open the magazine, Sunday Guardian, Rediff.com, Manoramaonline, Manipal University web portal, Malayala Manorama, Mathrubhumi and Prabhatha Resmi. He is a Visiting Professor of International Relations and Chair of the Centre for Diaspora Studies at the Central University of Kerala, Kasaragod. Mr. Sreenivasan was a Visiting Fellow on Foreign Policy at the Brookings Institution, Washington in 2009.`,
  `He is the author of seven books: 'Words, Words, Words — Adventures in Diplomacy', 'Encounters', 'Mattering to India', 'Applied Diplomacy Through the Prism of Mythology', 'Education of an Ambassador', 'Venkat Forever' and 'Modiplomacy'.`,
  `Mr. Sreenivasan is married to Lekha Sreenivasan, an Indian classical dancer and painter, and the founder chairperson of Karuna Charities International. The couple has two children — Sreenath Sreenivasan, a top-level consultant on social media in New York, and Sreekanth Sreenivasan, working for a US company, Katerra, in Dubai. Mr. Sreenivasan is a keen golfer.`,
  `His prizes and awards include the Prof. M.P. Paul Prize, the Harvey Memorial Prize, Rev. Fr. Panicker Memorial Award, Sree Chithira Thirunal National Award, the K.P.S. Menon Award and the Asianet News Award for completing 600 episodes of 'Videsha Vicharam'.`,
];

export const stats = [
  { value: "37", label: "Years in the Indian Foreign Service" },
  { value: "20+", label: "Years in multilateral diplomacy" },
  { value: "7", label: "Books authored" },
  { value: "600", label: "Episodes of 'Videsha Vicharam'" },
];

export const timeline = [
  { period: "2001–2004", role: "Ambassador & Permanent Representative of India to the UN, Vienna; Governor for India, IAEA; Ambassador to Austria & Slovenia; Representative to UNIDO, UNODC, UN COPUOS" },
  { period: "1997–2000", role: "Deputy Chief of Mission (Ambassadorial Rank), Embassy of India, Washington D.C." },
  { period: "1995–1997", role: "High Commissioner of India to Kenya & Permanent Representative of India to the UN, Nairobi" },
  { period: "1992–1995", role: "Ambassador & Deputy Permanent Representative of India to the United Nations, New York" },
  { period: "1989–1992", role: "Joint Secretary (UN), Ministry of External Affairs, New Delhi; Chairman, Committee on Programme & Coordination, New York" },
  { period: "1986–1989", role: "Ambassador to Fiji and eight other South Pacific Island States" },
  { period: "1980–1983", role: "Counsellor, Permanent Mission of India to the United Nations, New York" },
];

export const multilateral = [
  "Chairman, Working Group on Expansion of the Security Council, New York",
  "Chairman, Security Council Committee on Article 50 of the UN Charter",
  "Chairman, Security Council Committee on Arms Embargo Against South Africa",
  "Chairman, General Assembly Consultations on UN Funding for Development & UN Reform",
  "Vice-Chairman & Chairman, G-77, First Conference of Parties to UNFCCC, Berlin",
  "Chairman, Committee of Permanent Representatives to UNEP, Nairobi",
  "Vice-Chairman, HABITAT Conference, Istanbul",
  "Governor of India to the IAEA; Chairman of the Governing Council for Budgetary Consultations",
  "Chairman, UNODC Committee on the UN Convention Against Corruption",
  "Executive Director, Committee of Experts on 'IAEA 2020 and Beyond', Vienna (2005)",
];

export const books = [
  {
    id: 1,
    title: "Words, Words, Words — Adventures in Diplomacy",
    year: "Memoir",
    cover: "https://images.unsplash.com/photo-1727221167365-d365e63e7ebc",
    excerpt:
      "A memoir of a distinguished diplomatic career — the personalities, the crises and the quiet triumphs of representing India across five continents.",
    full: `Words, Words, Words — Adventures in Diplomacy is a memoir spanning four decades in the Indian Foreign Service. With warmth, wit and hard-won wisdom, it recounts a life lived from the corridors of the United Nations to the capitals of the world, offering rare insight into the art and craft of diplomacy.`,
  },
  {
    id: 2,
    title: "Encounters",
    year: "Essays",
    cover: "https://images.unsplash.com/photo-1607037183811-2a54d746cd35",
    excerpt:
      "Reflections on the remarkable personalities and defining moments encountered over a lifetime of public service and diplomacy.",
    full: `Encounters brings together reflections on the many remarkable leaders, thinkers and moments the author met over a lifetime of diplomacy — a mosaic of personal encounters that illuminate the human side of statecraft.`,
  },
  {
    id: 3,
    title: "Mattering to India",
    year: "Commentary",
    cover: "https://images.pexels.com/photos/16459372/pexels-photo-16459372.png",
    excerpt:
      "A close look at India's engagement with the world and the ideas, relationships and choices that shape its global standing.",
    full: `Mattering to India examines India's evolving place in the world — its relationships with the major powers, its multilateral engagements, and the choices that determine how much it matters on the global stage.`,
  },
  {
    id: 4,
    title: "Applied Diplomacy Through the Prism of Mythology",
    year: "Diplomacy",
    cover: "https://images.unsplash.com/photo-1763811939066-e984d42551e7",
    excerpt:
      "An imaginative exploration of statecraft and negotiation illuminated through the enduring stories and archetypes of Indian mythology.",
    full: `Applied Diplomacy Through the Prism of Mythology looks at the timeless principles of negotiation, strategy and statecraft through the rich narratives of Indian mythology, bridging ancient wisdom and modern practice for students and practitioners of diplomacy.`,
  },
  {
    id: 5,
    title: "Education of an Ambassador",
    year: "Memoir",
    cover: "https://images.unsplash.com/photo-1664785658580-07f819ce49cd",
    excerpt:
      "The making of a diplomat — from a Kerala classroom to the world's foremost multilateral forums.",
    full: `Education of an Ambassador traces the making of a diplomat, from the son of school teachers in Kerala to India's highest diplomatic assignments — a story of constant learning across countries, civilizations and languages.`,
  },
  {
    id: 6,
    title: "Venkat Forever",
    year: "Tribute",
    cover: "https://images.unsplash.com/photo-1673296630925-a16a5592cc14",
    excerpt:
      "A heartfelt tribute celebrating a cherished friendship and a life well lived.",
    full: `Venkat Forever is a heartfelt tribute — an affectionate portrait celebrating a cherished friendship and a life that left a lasting impression on all who knew it.`,
  },
  {
    id: 7,
    title: "Modiplomacy — Through a Shakespearean Prism",
    year: "2019",
    cover: "https://images.unsplash.com/photo-1727221167365-d365e63e7ebc",
    excerpt:
      "A unique work of contemporary history: the story of Prime Minister Narendra Modi's foreign policy in his first five years, seen through Shakespeare's timeless lens.",
    full: `Modiplomacy — Through a Shakespearean Prism is a unique work of contemporary history. It is the fascinating story of Prime Minister Narendra Modi's unique foreign policy in his first five years, told with wit and insight and interpreted through the timeless characters and dramas of Shakespeare.`,
  },
];

const fullSpeeches = [
  {
    id: 1,
    title: "Inaugural Address at the First Anniversary of the Kerala Economic Association",
    venue: "Kochi, Kerala",
    date: "May 8, 2015",
    excerpt:
      "I am afraid my stepping into the shoes of the Chief Minister of Kerala to inaugurate the annual Conference of the Kerala Economic Association is not very appropriate...",
    full: `I am afraid my stepping into the shoes of the Chief Minister of Kerala to inaugurate the annual Conference of the Kerala Economic Association is not very appropriate. The only thing common between the Chief Minister and myself in this context is that neither of us is an economist. Perhaps, the organizers did not want an economist to inaugurate the Conference and thus the choice may have fallen on me. A former President of France, Francois Mitterrand was asked as to how many books on economics he had on his bookshelf and he answered "none!" I am not very different as I have very few books on economics. Moreover, I have lived away from Kerala for nearly 40 years and all that I know about Kerala's economic development is from paper. I have been reading about the unique Kerala Model and feeling proud of it. Having come back to live in Kerala, I get the feeling that Kerala's economic development is more impressive on paper than in reality.

The famed high literacy rate in Kerala has not translated into better educational standards. We have just been through the SSLC results fiasco, revealing poor educational standards and inadequate expertise in handling computers. Our health indicators on paper do not match with the conditions in any Government hospital. One wonders whether the Kerala Model refers to a bizarre anomaly that the economists discovered in Kerala. With a fairly low economic growth, Kerala managed to develop the educational and social sectors. This could be attributed to the priorities of the rulers of Travancore and subsequent democratic leaders, supported by the missionaries, social reformers and community leaders, who gave special attention to education and health. One of them, Rani Gauri Parvati Bai declared long ago that it was the responsibility of the state to defray the cost of education of every citizen. The protests against the caste system took the form of mass education reform, which also helped.

Kerala's achievements in health and education have received attention worldwide. In spite of low per capita income, Kerala has low infant mortality, high literacy, high life expectancy, access to education, poverty reduction, palliative care and other indicators, which prompted a famous economist to remark, "Though mostly a land of paddy covered plains, Kerala stands out as the Mount Everest of social development." It was the Kerala Model that led to the UN Development Index, mainly because of the influential economist, Amartya Sen, who was an admirer of the Kerala Model. What we have achieved may have impressed external observers, but we could have achieved more if we had followed our tradition of tolerant pluralism and gender equality. We seem to have developed a mindset somewhere down the line, which resists change, even globalization, which has brought in opportunities and challenges. The general resistance to change has pervaded all sectors, including education. The stagnation and deterioration in the education system is appalling.

It is evident that a new political strategy is necessary to take the state forward. The recent debate between two giant economists, Jagdish Bhagwati and Amartya Sen was fascinating in the context of our development. Bhagwati attacked the Human Development Index and argued that Kerala's success in improving social outcomes had little to do with state policies. He preferred the Gujarat model of development, which focused on creation of prosperity and social spending. Sen felt that the Gujarat model would increase inequalities and hurt the minorities. The lesson we should learn from the debate is that we should strive for economic growth, while preserving our tradition of social spending and better distribution of wealth.

I would go one step further and say that Kerala should aim at following a big idea of Gross Domestic Happiness (GDH) as against Gross Domestic Product (GDP) put forward in 1971 by a tiny country, Bhutan. The idea was seen as an oddity, but now there is general recognition of this approach, which emphasizes the spiritual, physical, social and environmental health of citizens. Bhutan has made nature conservation and sustainability at the heart of the political agenda. Bhutan's record of doubling life expectancy, all children in schools, equitable social development, cultural promotion and conservation of the environment has given Bhutan the mythical status of a real life Shangri La. The world has begun to recognize the idea of Gross Domestic Happiness.

I am sure that the Kerala Economic Association will discuss these and other issues at its annual session. I was surprised that the KEA is only a year old. But apparently, Kerala economists have been active in the national level association over the years. I am happy to inaugurate the Conference and wish you well in your deliberations. Thank you.`,
  },
  {
    id: 2,
    title: "Graduates of the 21st Century — The Indian Education Congress 2015",
    venue: "New Delhi",
    date: "2015",
    excerpt:
      "I should begin with a plea for anticipatory bail. I have been a professional diplomat, who strayed into higher education just four years ago...",
    full: `I should begin with a plea for anticipatory bail. I have been a professional diplomat, who strayed into higher education just four years ago. I have been trying to mix diplomacy with education! My brief is very clear. I must speak to you about the requirements of successful graduates for the 21st century and outline the efforts made by Kerala to meet them in its institutions of higher learning.

Clearly, our higher education system is not geared for the challenges and opportunities of the 21st century. We need to catch up with the education revolution around the world, not only for our own needs, but also to avail of the demographic dividend on account of the largest group of young people in the world India will have in the next few years. Globalization and ICT have transformed expectations of graduates by the Governments, other employers and the society as a whole. The IT revolution, which came about without an owner's manual, needs to be deployed for the benefit of humanity.

The paradigm shift in education requires the graduates of tomorrow to be versatile and engaging, with multidisciplinary knowledge to communicate, collaborate and solve problems with critical and innovative thinking. Ethical and moral development, cognitive and interpersonal skills are equally important. They should have lifelong learning by using ICT techniques such as MOOCs, blended learning and flipped learning. We need nothing short of a Higher Education 2.0 while the rest of the world is moving into Higher Education 3.0.

Kerala has many assets to cope with the transformation required. The "Kerala Model" of development, which was the subject of a debate of the Titans between Jagdish Bhagwati and Amartya Sen, is a phenomenon in which, with modest economic growth, Kerala attained social development indicators to match the developed world. Education was a beneficiary, because of the imagination of the rulers of Travancore and the arrival of the missionaries. There was a Maharani, who declared that all expenses on education should be borne by the state. Kerala today has achieved access and equity in education, but its excellence is in question, as education has not moved with the times.

We have a blueprint for change. Stress has been placed on improving infrastructure, teachers training, use of technology in teaching, research, autonomy, internationalization and skills development. Choice-based semester system has been introduced and autonomous colleges have been set up. Skill development has become a part of the education scene. But much remains to be done. Kerala seems to lack the mindset to change and the money to invest in education. Some champions of change in all areas oppose changes in education. The huge gap between Kerala's capabilities in IT and the negligible use of technology in teaching needs to be filled.

Kerala has the tradition and the potential to excel in education, but mindset and money are the factors that hold us back. We tend to leave things in God's hands. After all, it is His country and He should take care of it! Thank you.`,
  },
  {
    id: 3,
    title: "Inaugural Address at the First Session of the Executive Council, Kerala State Higher Education Council",
    venue: "Thiruvananthapuram, Kerala",
    date: "November 2, 2011",
    excerpt:
      "Distinguished Member Secretary and Members of the Executive Council, I am delighted to congratulate you on your appointment...",
    full: `Distinguished Member Secretary and Members of the Executive Council, I am delighted to congratulate you on your appointment as the members of the Executive Council of the Kerala State Higher Education Council. I look forward to working with you to enhance the value and prestige of higher education in Kerala. You have brought to the Council a wealth of experience in the field of education. Each one of you has been chosen for your eminence and wisdom.

I have myself spent much of my working life in diplomacy, but my heart has been in education. With both my parents as school teachers, I have grown up in the midst of the joys and tears of educating young minds. I began my career as a teacher and even after I returned to India after 37 years abroad, I found immense satisfaction in teaching in several universities in India and outside.

Education and diplomacy have much in common. Unlike the other civil services, the Foreign Service has very few files and it demands constant education as we change countries and continents every three years. The challenge to cope with a new country, a new civilization, a new language and a new system can be met only by remaining a student throughout. Reading, research and writing are as essential for diplomats as for academics. Perhaps this is the reason why several distinguished diplomats — among them Sardar K.M. Panikkar, Shri G. Parthasarathy, Shri K.R. Narayanan and Shri Hamid Ansari — were appointed as Vice-Chancellors.

Allow me to pay a tribute to my predecessor, Dr. K.N. Panikkar, and his team for building up this Council from its very beginning and for laying the foundations for making higher education in Kerala purposeful and relevant to the demands of modern times. Our first task is to give attention to these reforms and promote their implementation after critically examining them in the light of past experience and applying the correctives as necessary. The scholarships scheme, the clustering of colleges, the Erudite Scheme, combating of ragging in the campuses, the Teacher Exchange Programme, and the publication of a journal have broad acceptance and must be pursued vigorously.

The general approach I would recommend is one of continuity and change. As a student in Kerala, I was often bewildered by frequent changes in the education system. We should not subject our student community to needless experimentation and change. Our purpose should be to fashion an education system that will meet the challenges of the future. Swami Vivekananda used to say that the end of all education is "man making." Education is "the manifestation of the perfection already in man," he observed.

The lofty ideals of a broad education that will elevate the society must be upheld, but after everything is said and done, our education system will be judged by the extent to which it equips our youth to compete nationally and globally for careers. Even while stressing the importance of the study of Indian languages, proficiency in the English language must be given high priority to make our graduates able to compete in the international markets. Study of international relations should also be expanded with the same objective.

The message that should go from this first meeting of the Council is that KSHEC will work with the clear purpose of making a difference to higher education in Kerala to enable our youth to meet the challenges of the present and future. We shall do this without fear or favour, affection or ill will and we expect, in turn, the full cooperation, support and goodwill from the entire academic community and the public at large. I have great pleasure and honour to inaugurate the first meeting of the Executive Council. Thank you.`,
  },
];

export const speeches = [
  {
    id: 38,
    title: "The IT Revolution Came Without an Instruction Manual",
    venue: "",
    date: "",
    excerpt:
      "A reflection on how the information technology revolution arrived without a manual, and our responsibility to harness it for human benefit.",
    full: "A reflection on how the information technology revolution arrived without an owner's manual, and the responsibility of education and society to deploy it wisely for the benefit of humanity.",
  },
  ...fullSpeeches,
  {
    id: 34,
    title: "Inaugural Address at the Kerala Economic Association",
    venue: "Kochi, Kerala",
    date: "",
    excerpt:
      "An inaugural address reflecting on the Kerala Model of development and the path to inclusive economic growth.",
    full: "An inaugural address to the Kerala Economic Association reflecting on the celebrated Kerala Model of development and the challenge of combining economic growth with the state's tradition of social spending.",
  },
  {
    id: 33,
    title: "Remarks at the Chancellor's Council",
    venue: "",
    date: "",
    excerpt:
      "Remarks on the reform and future direction of higher education in Kerala.",
    full: "Remarks delivered at the Chancellor's Council on the reform, autonomy and future direction of higher education in Kerala.",
  },
  {
    id: 32,
    title: "Valedictory Address at an International Conference on Space Law",
    venue: "",
    date: "",
    excerpt:
      "A valedictory address examining the evolving legal frameworks governing outer space.",
    full: "A valedictory address at an international conference on space law, examining the evolving legal frameworks that govern the peaceful uses of outer space.",
  },
  {
    id: 31,
    title: "English Literature and Diplomacy",
    venue: "",
    date: "",
    excerpt:
      "A talk on the surprising affinities between the study of English literature and the practice of diplomacy.",
    full: "A talk exploring the surprising affinities between the study of English literature and the practice of diplomacy, and how reading and writing shape a diplomat's craft.",
  },
  {
    id: 30,
    title: "Statements at the 44th Session of the Commission on Narcotic Drugs",
    venue: "Vienna, Austria",
    date: "March 22, 2001",
    excerpt:
      "India's statements outlining international cooperation against drug trafficking.",
    full: "India's statements at the 44th Session of the United Nations Commission on Narcotic Drugs in Vienna, outlining the case for stronger international cooperation against drug trafficking.",
  },
  {
    id: 29,
    title: "Credentials Speech as Ambassador of India to Austria",
    venue: "Vienna, Austria",
    date: "",
    excerpt:
      "Remarks on the presentation of credentials to the Federal President of Austria, Dr. Thomas Klestil.",
    full: "Remarks delivered on the occasion of the presentation of credentials as Ambassador of India to Austria to His Excellency the Federal President of the Republic of Austria, Dr. Thomas Klestil.",
  },
  {
    id: 28,
    title: "Credentials Speech as Ambassador of India to Slovenia",
    venue: "Ljubljana, Slovenia",
    date: "",
    excerpt:
      "Remarks on the presentation of credentials to the President of the Republic of Slovenia.",
    full: "Remarks delivered at the time of presentation of credentials as Ambassador of India to His Excellency the President of the Republic of Slovenia.",
  },
  {
    id: 26,
    title: "India's Nuclear Policy — Steady Objective, Narrowing Options",
    venue: "University of California, Los Angeles",
    date: "October 31, 1998",
    excerpt:
      "An inaugural address at UCLA explaining India's nuclear policy following the 1998 tests.",
    full: "An inaugural address at the University of California, Los Angeles, explaining India's nuclear policy in the wake of the 1998 tests — its steady strategic objectives and its narrowing options.",
  },
  {
    id: 25,
    title: "Message on the Occasion of the Republic Day Celebrations",
    venue: "",
    date: "January 29, 1999",
    excerpt:
      "A message on the occasion of India's Republic Day celebrations.",
    full: "A message to the Indian community on the occasion of India's Republic Day celebrations.",
  },
  {
    id: 24,
    title: "Christianity in India Is in No Danger",
    venue: "Ft. Lauderdale, Florida",
    date: "February 14, 1999",
    excerpt:
      "A statement at a Religious Harmony Meeting affirming India's tradition of pluralism.",
    full: "A statement at a Religious Harmony Meeting in Ft. Lauderdale, Florida, affirming India's deep-rooted tradition of religious pluralism and the security and freedom of its Christian community.",
  },
  {
    id: 23,
    title: "India–Pakistan Relations: Prospects for Conflict Resolution and Peace",
    venue: "Columbia University, New York",
    date: "March 6, 1999",
    excerpt:
      "A keynote address on the prospects for conflict resolution and lasting peace between India and Pakistan.",
    full: "A keynote address at a seminar at Columbia University, New York, on the prospects for conflict resolution and lasting peace between India and Pakistan.",
  },
  {
    id: 22,
    title: "Christians in Danger? Look at Kerala",
    venue: "India Abroad",
    date: "March 19, 1999",
    excerpt:
      "An article pointing to Kerala's long history of religious harmony and coexistence.",
    full: "An article in India Abroad pointing to Kerala's long history of religious harmony as evidence of India's enduring tradition of tolerance and coexistence.",
  },
  {
    id: 21,
    title: "Remarks at the 17th Annual Session of the AAPI",
    venue: "Anaheim, California",
    date: "June 25, 1999",
    excerpt:
      "Remarks to the American Association of Physicians of Indian Origin on the role of the diaspora.",
    full: "Remarks at the 17th annual session of the American Association of Physicians of Indian Origin (AAPI) in Anaheim, on the contribution and role of the Indian diaspora.",
  },
  {
    id: 20,
    title: "Nuclear Proliferation in Asia and the United States",
    venue: "National Press Club, Washington",
    date: "August 9, 1999",
    excerpt:
      "Remarks at a panel discussion on nuclear proliferation in Asia and the United States.",
    full: "Remarks at a panel discussion organised by the National Security News Service at the National Press Club on 'Nuclear Proliferation in Asia and the United States'.",
  },
  {
    id: 19,
    title: "Perspectives on the President's Trip to South Asia",
    venue: "Stimson Center & Brookings Institution",
    date: "March 15, 2000",
    excerpt:
      "A statement to a panel assessing the significance of the US President's visit to South Asia.",
    full: "A statement to the panel on 'Perspectives on the President's trip to South Asia', jointly organised by the Henry L. Stimson Center and the Brookings Institution.",
  },
  {
    id: 18,
    title: "U.S.–India Relations into the 21st Century — Post Presidential Visit",
    venue: "Washington, DC",
    date: "July 11, 2000",
    excerpt:
      "An address on the future of US–India relations after the presidential visit.",
    full: "An address at the summer meeting of the Indian American Forum of Political Education in Washington, DC, on the future of US–India relations into the 21st century following the presidential visit.",
  },
  {
    id: 14,
    title: "Board of Governors Meeting — Two Speeches",
    venue: "Vienna, Austria",
    date: "March 2001",
    excerpt:
      "Two statements delivered at the Board of Governors meeting of the IAEA in Vienna.",
    full: "Two statements delivered at the Board of Governors meeting of the International Atomic Energy Agency in Vienna, in March 2001.",
  },
  {
    id: 13,
    title: "Statement on the DPRK Resolution — IAEA Board of Governors",
    venue: "Vienna, Austria",
    date: "November 29, 2002",
    excerpt:
      "India's statement as Governor on the resolution concerning the DPRK at the IAEA.",
    full: "A statement by Ambassador T.P. Sreenivasan, Governor for India, on the DPRK resolution adopted on 29 November 2002 by the Board of Governors of the International Atomic Energy Agency.",
  },
  {
    id: 12,
    title: "International Women's Day at the Vienna International Centre",
    venue: "Vienna, Austria",
    date: "March 10, 2003",
    excerpt:
      "Remarks on International Women's Day at the Vienna International Centre.",
    full: "Remarks by Ambassador T.P. Sreenivasan of India on the occasion of International Women's Day at the Vienna International Centre.",
  },
  {
    id: 11,
    title: "The United Nations in a Changing World",
    venue: "Management Centre, Innsbruck, Austria",
    date: "March 22, 2003",
    excerpt:
      "A speech on the role of the United Nations in a rapidly changing world.",
    full: "A speech delivered by Ambassador T.P. Sreenivasan of India at the Management Centre, Innsbruck, on the evolving role of the United Nations in a rapidly changing world.",
  },
];

export const writeups = [
  { id: 1, title: "Education must be Up to Date", source: "Column", date: "" },
  { id: 2, title: "Pacific Energy Summit 2015, Beijing", source: "Column", date: "2015" },
  { id: 3, title: "Cuban Cigars — the Ultimate Temptation", source: "Column", date: "" },
  { id: 4, title: "Obama's Nobel No Longer Undeserved", source: "Column", date: "" },
  { id: 5, title: "Narasimha Rao Carried His Nuclear Secrets to His Grave", source: "Column", date: "" },
  { id: 6, title: "Nuclear Negotiations at a Delicate Stage", source: "Column", date: "" },
  { id: 7, title: "Perils of the Apparel", source: "Column", date: "" },
  { id: 8, title: "The Elusive Horseshoe Table", source: "Column", date: "" },
  { id: 9, title: "Making and Unmaking of Foreign Secretaries", source: "Column", date: "" },
  { id: 10, title: "The Coup that Changed the Diaspora Policy", source: "Column", date: "" },
  { id: 11, title: "POTUS at the Parade: A Game Changer", source: "Column", date: "" },
  { id: 12, title: "The Quest for a New UN Chief", source: "Column", date: "" },
  { id: 13, title: "UN Reforms", source: "Column", date: "" },
  { id: 14, title: "Lobbying in Washington", source: "The Tribune, Chandigarh", date: "March 5, 2005" },
  { id: 15, title: "Sree Chithira Thirunal Memorial Lecture", source: "Lecture", date: "" },
  { id: 16, title: "India Abroad Piece", source: "Column", date: "" },
  { id: 17, title: "A Contentious Report by UN Panel", source: "Column", date: "" },
].map((w) => ({
  ...w,
  excerpt: `${w.title} — a commentary by Ambassador T.P. Sreenivasan${
    w.source ? `, published in ${w.source}` : ""
  }${w.date ? ` (${w.date})` : ""}, reflecting on India's foreign policy and world affairs.`,
}));

export const interviews = [
  {
    id: 1,
    title: "In Conversation: A Career in the Indian Foreign Service",
    outlet: "Interview with Arjun R. Shankar",
    date: "2021",
    excerpt:
      "A wide-ranging conversation about a life in diplomacy — the personalities, the postings and the lessons of 37 years in the Indian Foreign Service.",
    videoId: "QZMmfruWjSQ",
  },
  {
    id: 2,
    title: "The Charms and Challenges of a Diplomatic Career",
    outlet: "Video Interview",
    date: "",
    excerpt:
      "Reflections on the rewards and difficulties of representing India abroad, and what draws a young person to the world of diplomacy.",
    videoId: "PD4RJ8a_qJ4",
  },
  {
    id: 3,
    title: "Perspectives on the G20 Summit",
    outlet: "Video Interview",
    date: "2023",
    excerpt:
      "An analysis of India's presidency of the G20 and the summit's significance for India's standing in a changing world order.",
    videoId: "y4JtLGDUVME",
  },
  {
    id: 4,
    title: "On International Relations and Diplomacy",
    outlet: "Video Interview",
    date: "",
    excerpt:
      "A discussion on international relations, India's foreign policy and the enduring craft of diplomacy in the twenty-first century.",
    videoId: "pDOaQOruKYc",
  },
  {
    id: 5,
    title: "A Diplomatic Journey — Conversations on World Affairs",
    outlet: "Video Interview",
    date: "",
    excerpt:
      "Insights on global developments, the balance of power among the major nations, and India's evolving role on the world stage.",
    videoId: "vKNebSP5GrQ",
  },
];

export const galleryPhotos = [
  { id: "r1", url: "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/smgtjp2r_TPS-image1.jpg", caption: "T.P. Sreenivasan" },
  { id: "r2", url: "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/d2gjlxpu_TPS-image2.jpg", caption: "Delivering an address" },
  { id: "r3", url: "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/w0wp3j0k_tps-photo6.jpg", caption: "T.P. Sreenivasan" },
  { id: "r4", url: "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/hk8k3016_tps-photo1.jpg", caption: "T.P. Sreenivasan" },
  { id: "r5", url: "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/9g7n0ly2_tps-photo7.jpg", caption: "Reading from a book at a public event" },
  { id: "r6", url: "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/lr947vzg_tps-photo8.jpg", caption: "In a television studio interview" },
  { id: "r7", url: "https://customer-assets-wrfwihn1.emergentagent.net/job_author-showcase-tp/artifacts/z6abcijs_tps-photo6.jpg", caption: "T.P. Sreenivasan" },
  { id: 1, url: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxjb25mZXJlbmNlJTIwc3BlYWtlcnxlbnwwfHx8fDE3ODcwNTgzMzh8MA&ixlib=rb-4.1.0&q=85", caption: "Addressing an international conference" },
  { id: 2, url: "https://images.unsplash.com/photo-1607037183811-2a54d746cd35", caption: "United Nations General Assembly Hall" },
  { id: 3, url: "https://images.pexels.com/photos/19149640/pexels-photo-19149640.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Homeland — the Taj Mahal" },
  { id: 4, url: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxjb25mZXJlbmNlJTIwc3BlYWtlcnxlbnwwfHx8fDE3ODcwNTgzMzh8MA&ixlib=rb-4.1.0&q=85", caption: "Panel discussion on foreign policy" },
  { id: 5, url: "https://images.pexels.com/photos/16459372/pexels-photo-16459372.png", caption: "Flags of the nations, Geneva" },
  { id: 6, url: "https://images.unsplash.com/photo-1763510499721-9d02fb132b9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHx3b3JsZCUyMGxhbmRtYXJrc3xlbnwwfHx8fDE3ODcwNTgzMzh8MA&ixlib=rb-4.1.0&q=85", caption: "Sydney — South Pacific posting" },
  { id: 7, url: "https://images.unsplash.com/photo-1727221167365-d365e63e7ebc", caption: "The United Nations, New York" },
  { id: 8, url: "https://images.unsplash.com/photo-1717245797618-785a256e8034?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHx3b3JsZCUyMGxhbmRtYXJrc3xlbnwwfHx8fDE3ODcwNTgzMzh8MA&ixlib=rb-4.1.0&q=85", caption: "Paris" },
  { id: 9, url: "https://images.pexels.com/photos/15400097/pexels-photo-15400097.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "On assignment in Italy" },
  { id: 10, url: "https://images.unsplash.com/photo-1664785658580-07f819ce49cd", caption: "Diplomatic mission" },
];

export const navLinks = [
  { label: "About", path: "/about" },
  { label: "Books", path: "/books" },
  { label: "Speech", path: "/speech" },
  { label: "Write Up", path: "/writeup" },
  { label: "Interviews", path: "/interviews" },
  { label: "Photo Gallery", path: "/gallery" },
  { label: "Get in Touch", path: "/contact" },
];
